<div class="dialog-header">
	<div class="header-title"><span style="font-size: 120%;">{{dialogHeader}}</span></div>

	<div class="buttons-block">
		<button class="header-button" mat-button (click)="submitOrder()"
			[disabled]="showLoadingSpinner || submitLoading"
			[ngClass]="{'disabled-button': showLoadingSpinner || submitLoading}">
			<span *ngIf="!submitLoading">Submit</span>
			<lib-mini-progress-spinner *ngIf="submitLoading"></lib-mini-progress-spinner>
		</button>
	</div>

	<button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
		<mat-icon>clear</mat-icon>
	</button>
</div>

<div class="middle-content">
	<div class="text-block" *ngIf="!showLoadingSpinner">
		<textarea matInput [required]="true" [(ngModel)]="textAreaMessage" name="message"></textarea>
	</div>
	<div class="pdf-block">
		<lib-progress-spinner *ngIf="showLoadingSpinner"></lib-progress-spinner>

		<ngx-extended-pdf-viewer [src]="blobUrl" [enablePinchOnMobile]="true" [zoom]="'page-width'"
			[showHandToolButton]="true" [showBookmarkButton]="false" [minZoom]="0.8" [showOpenFileButton]="false">
		</ngx-extended-pdf-viewer>
	</div>
</div>